<template>
    <div class="form-field" :class="{ required }">

        <ValidationProvider :name="name" v-slot="{ errors }" persist :rules="rules">

            <div class="form-group">

                <div class="form-field-label" :class="{'validation-error': errors.length > 0 }">{{label}}</div>

                <div v-for="(option, idx) in options" :key="option + '-' + idx" class="form-check form-check-inline">

                    <input class="form-check-input"
                           :class="{'validation-error': errors.length > 0 }"
                           type="radio"
                           :name="name"
                           :id="name + '-' + idx"
                           v-model="value"
                           :value="option"
                           @change="$emit('input', $event.target.value)"
                           @input="$emit('input', $event.target.value)"
                    >
                    <label class="form-check-label d-flex align-items-center"
                           :for="name + '-' + idx"
                           :class="{
                               'validation-error': errors.length > 0,
                               'selected': value === option
                           }"
                    >
                        <svg v-show="value !== option" class="bi bi-circle" width="1em" height="1em" viewBox="0 0 16 16"
                             fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 108 1a7 7 0 000 14zm0 1A8 8 0 108 0a8 8 0 000 16z"
                                  clip-rule="evenodd"/>
                        </svg>
                        <svg v-show="value === option" class="bi bi-circle-fill" width="1em" height="1em"
                             viewBox="0 0 16 16" fill="currentColor"
                             xmlns="http://www.w3.org/2000/svg">
                            <circle cx="8" cy="8" r="8"/>
                        </svg>
                        <span class="pl-2">{{option}}</span>
                    </label>

                </div>

                <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

            </div>

        </ValidationProvider>
    </div>
</template>

<script>
    import {ValidationProvider} from "vee-validate"

    export default {
        name: "RadioInput",
        props: ["name", "value", "label", "options", "rules", "required"],
        data() {
            return {
                focussedOption: ''
            }
        },
        components: {
            ValidationProvider
        }
    }
</script>

<style lang="scss" scoped>

    .required {

        .form-field-label:after {
            content: '*';
            color: red;
        }
    }

    input {
        visibility: visible !important;
        opacity: 0 !important;
        height: 0;
        width: 0;
    }

    input:focus, input:focus + label {
        border-radius: 0.25em;
        border: 3px solid lightblue;
    }

    label.form-check-label {
        font-weight: 400;
        display: block;
        width: 100%;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        color: #2e3031;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
        transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;

        &.selected {
            border: 2px solid #2e3031;
            font-weight: bold;
        }

        &:hover {
            cursor: pointer;
        }
    }
</style>
